import { Result } from 'domain/types';

import ReadLinksClient from 'use-case/link/read/readLinksClient';
import ReadLinksCriteria from 'use-case/link/read/readLinksCriteria';
import Link from 'domain/entity/link';

export type ReadLinksResult = Result<Link[]>;
export type ReadLinks = (criteria: ReadLinksCriteria) => Promise<ReadLinksResult>;

export default (readLinkClient: ReadLinksClient): ReadLinks => (criteria: ReadLinksCriteria): Promise<ReadLinksResult> =>
    readLinkClient(criteria);
